// extracted by mini-css-extract-plugin
export var label = "_ak-1";
export var reminder = "_ak-0";